import { render, staticRenderFns } from "./after-sales-tracking.vue?vue&type=template&id=6b0f518b&scoped=true"
import script from "./after-sales-tracking.vue?vue&type=script&lang=js"
export * from "./after-sales-tracking.vue?vue&type=script&lang=js"
import style0 from "./after-sales-tracking.vue?vue&type=style&index=0&id=6b0f518b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b0f518b",
  null
  
)

export default component.exports